import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DTOPhoto } from '../../../../../@core/models/DTOPhoto';
import { ParcelhistoryService } from '../../../../../@core/services/parcelhistory.service';
import { PhotoService } from '../../../../../@core/services/photo.service';
import { SignatureService } from '../../../../../@core/services/signature.service';

@Component({
  selector: 'crm-show-photos-dialog',
  templateUrl: './crm-show-photos-dialog.component.html',
  styleUrls: ['./crm-show-photos-dialog.component.scss']
})
export class CrmShowPhotosDialogComponent implements OnInit {
  public parcelId: string;
  public loading: boolean = false;
  public sub: Subscription;
  public sigID: any;
  public photos: DTOPhoto[];

  constructor(
    public dialogRef: MatDialogRef<CrmShowPhotosDialogComponent>,
    public _photoService: PhotoService,
    public _signatureService: SignatureService,
    public translateService: TranslateService,
    public _parcelhistoryService: ParcelhistoryService,
    public toastservice: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.photos = data.photos;
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  public close(): void {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {}
}
